module.exports = __webpack_public_path__ + "static/server_1-8fabd829acb05c63eeabd60da43eba57.gif";